import { Injectable } from "@angular/core";
import { ActionSheetController, Platform } from "@ionic/angular";
import { CameraDirection, CameraResultType, CameraSource, Camera } from '@capacitor/camera';
import { FilePicker } from '@capawesome/capacitor-file-picker';
import { ObservablesService } from "./observables.service";
import { EnumService } from "./enum.service";
// import { Camera as NativeCamera, CameraOptions } from "@ionic-native/camera/ngx";
import { UtilService } from "./util.service";
import { StaticDataService } from "./static-data.service";

@Injectable({
    providedIn: "root",
})
export class PhotoService {
    constructor(
        public platform: Platform,
        public actionSheetController: ActionSheetController,
        private observablesService: ObservablesService,
        // private camera: NativeCamera
    ) { }

    public chooseMediaFromAlbum = (callBack: any, currentAttachCount = 0) => {
        this.triggerUpload(
            "album",
            (media: any, name:string) => {
                if (media.indexOf("image") !== -1) {
                    callBack && callBack(media, "image",name);
                } else if (media.indexOf("video") !== -1) {
                    callBack && callBack(media, "video",name);
                } else {
                    callBack && callBack(media, "image",name);
                }
            },
            "photovideo",
            currentAttachCount
        );
    };

    triggerUpload(type = "album", callBack: any = null, mediaType = "photo", currentAttachCount) {
        let input: any = document.createElement("input");
        input.type = "file";
        input.multiple = true

        if (mediaType === "photo") {
            input.accept = "image/png,image/jpeg";
        } else if (mediaType === "photovideo") {
            input.accept =
                "image/png,image/jpeg,image/jpg,image/gif,image/svg,image/ico,image/tiff,image/webp,video/mov,video/mp4,video/mpeg,video/wmv,video/avi,video/mov,video/flv,video/mkv,video/webm,video/m4v";
        }
        if (type === "camera") {
            input.capture = "environment";
            // input.capture = 'user'; //for front
        } else {
            // input.capture = 'filesystem';
        }
        input.onchange = (event: any) => {
            const fileCount = event.target.files.length;
            if (fileCount + currentAttachCount <=20){

            //if (canMultipleSelect && fileCount > 0) {

            for (let index = 0; index < fileCount; index++) {
                let reader = new FileReader();
                const file = event.target.files[index];
                reader.readAsDataURL(file);
                reader.onload = async () => {
                    const base64String = reader.result as string;
                    base64String.replace("data:", "").replace(/^.+,/, "");
                    input = null;
                    callBack && callBack(base64String,file.name);
                };
                reader.onerror = async () => {
                    callBack && callBack("");
                };
            }
            /*} else {
                const file = event.target.files[0];

                //Convert file object to base64 string
                reader.onloadend = async () => {
                    const base64String = reader.result as string;
                    base64String.replace('data:', '').replace(/^.+,/, '');
                    callBack && callBack(base64String);
                    input = null;
                };
                reader.readAsDataURL(file);
            }*/
            } else{
                this.displayLimitMessage()              
            }
        };
        setTimeout(function () {
            input.click();
        }, 200);
    }
    async displayLimitMessage(){
        const actionSheet = await this.actionSheetController.create({
            header: "Limit reached",
            subHeader: "Each question is limited to 20 attatchments",
            cssClass: "my-custom-class",
            buttons: [{
                    text: "Cancel",
                    icon: "close",
                    role: "cancel",
                    handler: () => { },
                },
            ],
        });
        await actionSheet.present();
    }

    async takePhotoFromNativeCamera(
        callBack,
        isFrontCamera = false,
        isSquarePhoto = false
    ) {
        const subscribe = this.observablesService
            .getObservable(EnumService.ObserverKeys.APP_RESTORED_RESULT)
            .subscribe((data) => {
                callBack(data.data);
                subscribe.unsubscribe();
            });

        let allowEditing = false;
        if (this.platform.is("ios") && isSquarePhoto) {
            allowEditing = true;
        }

        // if (UtilService.isLocalHost() || UtilService.isWebApp()) {
        try {
            const capturedPhoto = await Camera.getPhoto({
                resultType: CameraResultType.DataUrl,
                source: CameraSource.Camera,
                quality: this.platform.is('ios') ? 50 : StaticDataService.photoQuality,
                allowEditing,
                height: StaticDataService.photoHDHeight,
                width: StaticDataService.photoHDWidth,
                correctOrientation: true,
                direction: isFrontCamera
                    ? CameraDirection.Front
                    : CameraDirection.Rear,
            });
            try {
                subscribe.unsubscribe();
                if (capturedPhoto) {
                    if (isSquarePhoto) {
                        UtilService.crop(capturedPhoto, 1).then((res: any) => {
                            callBack(res);
                        });
                    } else {
                        callBack(capturedPhoto);
                    }
                }
            } catch (err) {
                console.log("Photo get Error " + JSON.stringify(err));
            }
        
        } catch (err) {
            console.log("Photo get Error " + JSON.stringify(err));
        } 
        // else {
        //     const options: CameraOptions = {
        //         quality:StaticDataService.photoQuality,
        //         destinationType: this.camera.DestinationType.FILE_URI,
        //         encodingType: this.camera.EncodingType.JPEG,
        //         sourceType: this.camera.PictureSourceType.CAMERA,
        //         correctOrientation: true,
        //         allowEdit: allowEditing,
        //         targetHeight: StaticDataService.photoHDHeight,
        //         targetWidth: StaticDataService.photoHDWidth,
        //         cameraDirection: isFrontCamera
        //             ? this.camera.Direction.FRONT
        //             : this.camera.Direction.BACK,
        //     };

        //     this.camera.getPicture(options).then(
        //         (imageData) => {
        //             // const base64Image = "data:image/jpeg;base64," + imageData;
        //             if (imageData) {
        //                 if (isSquarePhoto) {
        //                     UtilService.crop(imageData, 1).then((res: any) => {
        //                         callBack({ dataUrl: res });
        //                     });
        //                 } else {
        //                     callBack({ dataUrl: imageData });
        //                 }
        //             }
        //             subscribe.unsubscribe();
        //         },
        //         (err) => {
        //             // Handle error
        //             console.log("Photo get Error " + JSON.stringify(err));
        //         }
        //     );
        // }
    }

    cleanCamera() {
        //this.camera.cleanup().then(() => { });
    }

    async takePhotoFromCamera(
        callBack,
        isFrontCamera = false,
        isSquarePhoto = false
    ) {
        const subscribe = this.observablesService
            .getObservable(EnumService.ObserverKeys.APP_RESTORED_RESULT)
            .subscribe((data) => {
                callBack(data.data);
                subscribe.unsubscribe();
            });
        let allowEditing = false;
        if (this.platform.is("ios") && isSquarePhoto) {
            allowEditing = true;
        }

        const cameraOption: any = {
            resultType: CameraResultType.DataUrl,
            source: CameraSource.Camera,
            quality: this.platform.is('ios') ? 50 : StaticDataService.photoQuality,
            allowEditing,
            height: StaticDataService.photoHDHeight,
            correctOrientation: true,
            preserveAspectRatio: true,
            direction: isFrontCamera
                ? CameraDirection.Front
                : CameraDirection.Rear,
        };

        const capturedPhoto = await Camera.getPhoto(cameraOption);
        try {
            if (capturedPhoto) {
                if (isSquarePhoto) {
                    UtilService.crop(capturedPhoto, 1).then((res: any) => {
                        callBack(res);
                    });
                } else {
                    callBack(capturedPhoto);
                }
            }
        } catch (err) {
            console.log("Photo get Error " + JSON.stringify(err));
        }
    }

    // async takePhotoFromGallery(
    //     callBack,
    //     isAllMedia = false,
    //     isFileUrl = false
    // ) {
    //     const options: CameraOptions =
    //     {
    //         quality: this.platform.is('ios') ? 50 : StaticDataService.photoQuality,
    //         encodingType: this.camera.EncodingType.JPEG,
    //         destinationType: isFileUrl
    //             ? this.camera.DestinationType.FILE_URI
    //             : this.camera.DestinationType.DATA_URL,
    //         mediaType: isAllMedia
    //             ? this.camera.MediaType.ALLMEDIA
    //             : this.camera.MediaType.PICTURE,
    //         sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
    //         correctOrientation: true,
    //         targetHeight: StaticDataService.photoHDHeight,
    //         targetWidth: StaticDataService.photoHDWidth,
    //     };

    //     this.camera
    //         .getPicture(options)
    //         .then((imageData) => {

    //             // imageData is either a base64 encoded string or a file URI
    //             // If it's base64 (DATA_URL):
    //             if (imageData) {
    //                 if (
    //                     StaticDataService.videoFormats.indexOf(
    //                         imageData.split(".").pop().toLowerCase()
    //                     ) !== -1
    //                 ) {
    //                     let fileName = imageData.split('/').pop().split('?')[0];
    //                     callBack({ dataUrl: imageData, isVideo: true }, fileName );
    //                 } else {
    //                     if (isFileUrl) {
    //                         let fileName = imageData.split('/').pop().split('?')[0];
                           
    //                         callBack({ dataUrl: imageData.split("?")[0]}, fileName );
    //                     } else {
    //                         const base64Image =
    //                             "data:image/jpeg;base64," + imageData;
    //                         callBack({ dataUrl: base64Image });
    //                     }
    //                 }
    //             }
    //         })
    //         .catch((err) => {
    //             console.log("Photo get Error " + JSON.stringify(err));
    //         });
    // }

    async takePhotoFromGallery(callBack: Function, isAllMedia = false, isFileUrl = false) {
        try {
          // Capacitor Camera only supports images here
          const photo = await Camera.getPhoto({
            quality: this.platform.is('ios') ? 50 : StaticDataService.photoQuality,
            resultType: CameraResultType.Uri,
            source: CameraSource.Photos,
            correctOrientation: true,
            width: StaticDataService.photoHDWidth,
            height: StaticDataService.photoHDHeight,
          });
      
          if (photo) {
            const fileUri = photo.path ?? photo.webPath ?? '';
            callBack({ dataUrl: fileUri, isVideo: false }, fileUri.split('/').pop() || '');
          }
        } catch (error) {
          console.error('Error picking photo from gallery:', error);
        }
      }

    async pickMultipleMedia(callBack: (path: string, isVideo: boolean, name: string) => void, currentAttachCount = 0) {
        try {
            const result = await FilePicker.pickMedia({ limit: 0 });
            const files = result.files;
            if (files.length + currentAttachCount > 20) {
                this.displayLimitMessage();
                return;
            }
            for (const file of files) {
                const isVideo = file.mimeType.startsWith('video/');
                callBack(file.path, isVideo, file.name);
            }
        } catch (err) {
            console.log('FilePicker error: ' + JSON.stringify(err));
        }
    }
}
